import { render, staticRenderFns } from "./sysuser.vue?vue&type=template&id=473f23da&scoped=true"
import script from "./sysuser.vue?vue&type=script&lang=js"
export * from "./sysuser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473f23da",
  null
  
)

export default component.exports